import Dexie from 'dexie';

const db = new Dexie('carcheck');
db.version(1).stores({
  forms: ', status, localStatus',
  // dashboard : ''
});

export default db;
